import { AsyncSelect } from '@/components';
import { useCallback, useState } from 'react';
import { useProjectLookupSource } from '../Projects.Common';
import { PROJECT_HOME_STORAGE_KEY } from '../DevelopScope.List';
import { useFirstRender } from '@/utils';

interface Props {
  communityId: string;
  className?: string;
  onSelected: (id: string | undefined) => any;
  selectedId: string | undefined;
}

export function useProjectSelectedState(
  initialId?: string,
): Pick<Props, 'onSelected' | 'selectedId'> {
  const [selectedId, setSelectedId] = useState<string | undefined>(initialId);

  const isFirst = useFirstRender();
  const onSelected = useCallback(
    (id: string | undefined) => {
      if (!isFirst) {
        sessionStorage.removeItem(PROJECT_HOME_STORAGE_KEY);
      }

      setSelectedId(id);
    },
    [isFirst],
  );

  return { selectedId, onSelected };
}

export function SearchProjectInput(props: Props) {
  const { communityId, className, onSelected, selectedId } = props;
  const dataSource = useProjectLookupSource({
    communityIds: [communityId],
  });

  return (
    <AsyncSelect
      className={className}
      value={selectedId}
      onChange={onSelected}
      dataSource={dataSource}
      preload
      placement="bottomLeft"
      allowClear={false}
    />
  );
}
